import router, { route, ROUTE_NAME } from "@/router";
import { t } from "@/plugins/vue-i18n";
import { ROUTE_NAME_WEB } from "@/router/webRoutes";

import { useSupplierStore } from "@/stores/suppliers";
import { useListStore } from "@/stores/lists";
import { useNotificationStore } from "@/stores/notification";
import { useUserStore } from "@/stores/user";
import { useLocationStore } from "@/stores/locations";

import { useLoader } from "@/composables/useLoader";

import { routeEnvironment } from "@/functions/enviroment";

import { Location } from "@/types/location";
import { ref } from "vue";

export function useHome() {
    const userStore = useUserStore()
    const locationStore = useLocationStore()
    const supplierStore = useSupplierStore()
    const listStore = useListStore()
    const notificationStore = useNotificationStore()

    const { showLoading, hideLoading } = useLoader()
    const loadingLocations = ref<boolean>(false)

    const setup = async (): Promise<void>  => {
        supplierStore.clearStateVariables()
        listStore.clearStateVariables()
        notificationStore.clearStateVariables()
        locationStore.clearStateVariables()

        locationStore.activeLocation = null;
        loadingLocations.value = true
        await Promise.all([
            userStore.getMe(),
            locationStore.getLocations(true),
        ])
        loadingLocations.value = false
    }

    const selectLocation = async (location: Location, loading?: boolean): Promise<void> => {
        if (!loading) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            await showLoading(t('label.loading.location'))
        }

        const response = await userStore.getLocationPermissions(location.id)

        if (!response) {
            await hideLoading()
            return
        }

        //locationStore.getCachedValues(location.id)
        locationStore.activeLocation = location
        await router.push({
            name: routeEnvironment(ROUTE_NAME_WEB.DASHBOARD_HOME, route.value.query.origin as ROUTE_NAME ?? ROUTE_NAME.DASHBOARD_HOME),
            params: { locationId: location.id }
        })
        // const { testCount } = useApi()
        // testCount.value++

        await hideLoading()
    }

    const selectLocationById = async (locationId: string, loading?: boolean): Promise<void> => {
        const location = locationStore.locations?.find(location => location.id === locationId)

        if (!location) return;

        await selectLocation(location, loading)
    }

    const logoutUser = async (): Promise<void> => {
        await userStore.logoutUser()
        await router.push({ name: routeEnvironment(ROUTE_NAME_WEB.START, ROUTE_NAME.START) })
    }

    const changeLocation = async (locationId?: string): Promise<void> => {
        if (!locationId) return;

        await showLoading(t('label.loading.location'))
        await setup()
        await selectLocationById(locationId, true)
    }

    return {
        setup,
        selectLocation,
        selectLocationById,
        changeLocation,
        logoutUser,
        loadingLocations,
    }
}
